import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import debounce from "lodash.debounce";
import shortid from "shortid";

import WP from "WP";
import api from "api";
import { setCurrentView } from "store";

import SnowmobileForm from "./Forms/SnowmobileRentalForm";
import SkiPackageForm from "./Forms/SkiPackageRentalForm";
import EquipmentForm from "./Forms/EquipmentRentalForm";
import ProductCard from "./ProductCard";
import Container from "partials/Container";
import GridElement from "partials/GridElement";
import ErrorBoundary from "partials/ErrorBoundary";
import Html from "partials/Html";
import Footer from "partials/Footer";
import CookieNotice from "partials/CookieNotice";

import Media, { ScreenWidth } from "css/Media";

export class RentalPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rentals: [],
      isMobile: false,
      defaultValue: null,
      disabled: false,
      loading: true,
    };
    this.formId = "form-" + shortid.generate();
  }

  componentWillMount() {
    this.checkScreenSize();
  }

  componentDidMount() {
    this.props.setCurrentView(null);
    window.addEventListener(
      "resize",
      debounce(() => this.checkScreenSize()),
      500
    );
    this.preparePage();
  }

  componentDidUpdate(nextProps) {
    if (nextProps.page !== this.props.page) {
      this.preparePage();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  }

  checkScreenSize() {
    let isMobile = false;
    if (ScreenWidth.lessThan("s")) {
      isMobile = true;
    }
    this.setState({ isMobile: isMobile });
  }

  preparePage() {
    window.scrollTo(0, 0);
    api.pageFetcher
      .getBySlug({ slug: this.props.match.params.slug })
      .then((resp) => {
        let page = resp.data[0];
        this.props.setCurrentView(page);
        this.setState({ loading: false });
      });

    if (!this.props.page) return null;

    api.rentalProductsFetcher.getAll().then((result) => {
      let rentals = result.data.filter(
        (rental) => rental.rental_types[0] === this.props.page.acf.products
      );
      this.setState({
        rentals: rentals,
      });
    });
  }

  disableCards = () => {
    this.setState({ disabled: true });
  };

  getRentalTypeForm = () => {
    let product = this.state.rentals[0];

    if (product.acf.rental_type === "snowmobile") {
      return (
        <SnowmobileForm
          form_title={this.props.page.acf.form_title}
          form_text_content={this.props.page.acf.form_text_content}
          booking_email={this.props.page.acf.booking_email}
          products={this.state.rentals}
          defaultValue={this.state.defaultValue}
          disableCards={this.disableCards}
        />
      );
    } else if (product.acf.rental_type === "skis") {
      return (
        <SkiPackageForm
          form_title={this.props.page.acf.form_title}
          form_text_content={this.props.page.acf.form_text_content}
          booking_email={this.props.page.acf.booking_email}
          products={this.state.rentals}
          defaultValue={this.state.defaultValue}
          disableCards={this.disableCards}
        />
      );
    } else if (product.acf.rental_type === "equipment") {
      return (
        <EquipmentForm
          form_title={this.props.page.acf.form_title}
          form_text_content={this.props.page.acf.form_text_content}
          booking_email={this.props.page.acf.booking_email}
          products={this.state.rentals}
        />
      );
    }
  };

  handleClick = (product) => {
    const form = document.getElementById(this.formId);
    window.scrollTo({
      top: window.scrollY + form.getBoundingClientRect().top,
      left: 0,
      behavior: "smooth",
    });
    //form.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    let defaultValue = { value: product, label: product.acf.title };
    this.setState({ defaultValue: defaultValue });
  };

  sortProductsByOrder = () => {
    let sorted = this.state.rentals.sort((a, b) => {
      return a.acf.product_order - b.acf.product_order;
    });
    return sorted;
  };

  render() {
    const { page } = this.props;
    const { rentals, isMobile, disabled, loading } = this.state;

    if (!page || (page && loading)) return null;

    return (
      <Wrapper>
        <Container grid>
          <DescriptionGridElement
            colStart={{ default: 1, s: 7 }}
            colEnd={{ default: 8, s: 18 }}
            rowStart={1}
            justify='center'
          >
            <StyledHtml content>{page.acf.title}</StyledHtml>
            <StyledHtml content>{page.acf.description}</StyledHtml>
          </DescriptionGridElement>

          <ProductCardSectionGridElement
            colStart={{ default: 1, s: 3 }}
            colEnd={{ default: 8, s: 22 }}
            rowStart={2}
          >
            {rentals &&
            rentals.length &&
            rentals[0].acf.rental_type !== "equipment"
              ? this.sortProductsByOrder().map((product) => {
                  return (
                    <ProductCard
                      product={product}
                      key={product.id}
                      isMobile={isMobile}
                      handleClick={this.handleClick}
                      disabled={disabled}
                    />
                  );
                })
              : null}
          </ProductCardSectionGridElement>

          <FormSectionGridElement
            id={this.formId}
            colStart={{ default: 1, s: 5 }}
            colEnd={{ default: 8, s: 20 }}
            rowStart={3}
          >
            {rentals && rentals.length ? this.getRentalTypeForm() : null}
          </FormSectionGridElement>
        </Container>
        <ErrorBoundary for='Footer'>
          <Footer />
        </ErrorBoundary>
        <CookieNotice />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  page: state.currentView,
  rentals: state.rentals.posts[WP.lang] ? state.rentals.posts[WP.lang] : [],
  rental_types: state.rental_types.posts[WP.lang]
    ? state.rental_types.posts[WP.lang]
    : [],
});

const actions = {
  setCurrentView,
};

export default connect(mapStateToProps, actions)(withRouter(RentalPage));

const Wrapper = styled.section`
  scroll-behavior: smooth;
  width: 100%;
  padding-top: ${(props) => props.theme.spacing.blockS};

  ${Media.greaterThan("s")`
        padding-top: 220px;
    `}
`;

const DescriptionGridElement = styled(GridElement)`
  margin-bottom: ${(props) => props.theme.spacing.elementS};

  ${Media.greaterThan("s")`
        margin-bottom: ${(props) => props.theme.spacing.blockM};
    `}
`;

const StyledHtml = styled(Html)`
  text-align: center;

  h1 {
    margin-bottom: ${(props) => props.theme.spacing.contentXL};

    ${Media.greaterThan("s")`
            margin-bottom: ${(props) => props.theme.spacing.elementS};
        `}
  }

  p {
    font-size: 18px;
    line-height: 27px;

    ${Media.greaterThan("s")`
            ${(props) => props.theme.fonts.h5};
            line-height: 32px;
        `}
  }
`;

const ProductCardSectionGridElement = styled(GridElement)``;

const FormSectionGridElement = styled(GridElement)``;
